<app-eddashboard *ngIf="isEDSurveyManager" class="dashboard dashboard--ed"></app-eddashboard>
<app-viewer-dashboard *ngIf="isEDViewer" class="dashboard dashboard--ed"></app-viewer-dashboard>
<app-user-dashboard *ngIf="isUser" class="dashboard dashboard--user"></app-user-dashboard>
